import { Box } from '@mui/material'

// Types
import type { FloatProps } from '@/types/components/atoms/animation'

// Gently bobs its content up and down, forever; a CSS animation so it runs off the main thread
const FloatAtom = (props: FloatProps) => {
	// Props
	const { children, delay = 0 } = props

	return (
		<Box
			sx={{
				'@keyframes floatBob': { '0%, 100%': { translate: '0 0' }, '50%': { translate: '0 -10px' } },
				'@media (prefers-reduced-motion: no-preference)': { animation: `floatBob 5s ease-in-out ${delay}s infinite` }
			}}
		>
			{children}
		</Box>
	)
}

export default FloatAtom
